﻿export const RIGHT = 'RIGHT';
export const CLICK = 'CLICK';
export const DOUBLE_CLICK = 'DOUBLE_CLICK';